import React, { useState, useRef, useEffect } from "react";
import "./../managerPage/css/card.css";
import "./../managerPage/css/table.css";
import "./../managerPage/css/form.css";
import "./../managerPage/css/dropdown.css";
import { IoIosSearch } from "react-icons/io";
import { RiDeleteBin6Line } from "react-icons/ri";
import img from "../../assets/images/person_four.jpg";
import { IoIosCloseCircle } from "react-icons/io";
import { LuDownload } from "react-icons/lu";
import jsPDF from "jspdf";
import "tippy.js/dist/tippy.css";
import Tippy from "@tippyjs/react";
import { TiArrowSortedUp } from "react-icons/ti";
import autoTable from "jspdf-autotable";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import {
  useGetUserByEmailQuery,
  useGetUsersQuery,
  useGetAcademyQuery,
} from "../../slices/userApiSlice";
import {
  useGetMaintenanceReportsQuery,
  useGetMaintenanceRequestQuery,
  useGetPreventiveMaintenanceReportsByAcademyQuery,
} from "../../slices/maintenanceApiSlice";
import { useGetAssetQuery } from "../../slices/assetApiSlice";
import Select from "react-select";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import {
  FileText,
  Clock,
  Calendar,
  MapPin,
  Wrench,
  Users,
  DollarSign,
  Info,
  Image as ImageIcon,
  Download,
} from "lucide-react";

const SupervisorMReport = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [editableData, setEditableData] = useState({
    Additional_cost: "",
    Additional_Hour: "",
    Remarks: "",
  });

  const rowsPerPage = 10;

  const { data: maintenanceRequest } = useGetMaintenanceRequestQuery();
  const { data: academy } = useGetAcademyQuery();
  const { data: users } = useGetUsersQuery();
  const { data: assets } = useGetAssetQuery();

  const selectUserInfo = (state) => state.auth.userInfo || {};
  const getUserEmail = createSelector(
    selectUserInfo,
    (userInfo) => userInfo?.username || "",
  );
  const email = useSelector(getUserEmail);

  const { data: userByEmial } = useGetUserByEmailQuery(email);
  const userAcademyId = userByEmial?.user?.academyId;

  // Fetch reports specifically for this academy
  const {
    data: maintenanceReport,
    isLoading: isReportsLoading,
    error: reportsError,
  } = useGetPreventiveMaintenanceReportsByAcademyQuery(userAcademyId, {
    skip: !userAcademyId, // Skip if academy ID isn't available yet
  });

  const [data, setData] = useState([]);

  useEffect(() => {
    if (
      maintenanceReport &&
      maintenanceRequest &&
      academy &&
      userByEmial &&
      users &&
      assets
    ) {
      // The old filtering logic (mergedData = maintenanceReport.map...) is now simplified
      // because `maintenanceReport` only contains reports for this academy.

      const loginAcademyId = userByEmial.user.academyId?.trim().toLowerCase();

      // We still need to map to attach extra details (AssetName, AcademyName, etc)
      // but we don't need to filter by academy anymore (backend does it).
      const mergedData = maintenanceReport
        .map((report) => {
          const matchingRequest = maintenanceRequest.find(
            (request) =>
              request.maintenanceID === report.preventiveMaintenanceID,
          );

          if (!matchingRequest) return null;

          // Legacy check: redundant if backend logic is correct, but safe to keep for data integrity
          // const requestUser = users.find((user) => user.userId === matchingRequest.userID);
          // if (!requestUser) return null;
          // const requestAcademyId = requestUser.academyId?.trim().toLowerCase();
          // if (requestAcademyId !== loginAcademyId) return null;

          // ✅ Filter out incomplete reports - only show submitted reports (Can also be moved to backend later)
          const isReportComplete =
            report.totalCost &&
            report.totalCost > 0 &&
            report.information &&
            String(report.information).trim() !== "" &&
            report.partsUsed &&
            String(report.partsUsed).trim() !== "" &&
            report.images &&
            Array.isArray(report.images) &&
            report.images.length > 0 &&
            report.technicians &&
            String(report.technicians).trim() !== "";

          // Only include reports that have been properly submitted
          if (!isReportComplete) return null;

          // 🔍 Count technicians
          let total = 0;
          if (report.technicians) {
            const technicianList = report.technicians
              .split(",")
              .filter((email) => email.trim() !== "");
            total = technicianList.length;
          }

          // We can just use the login academy directly since reports are filtered by it
          const matchingAcademy = academy.find(
            (a) => a.academyId?.trim().toLowerCase() === loginAcademyId,
          );

          const matchingAsset = assets.find(
            (asset) => asset.assetCode === matchingRequest.assetCode,
          );

          const merged = {
            ...report,
            academyId: loginAcademyId,
            academyName: matchingAcademy?.name || "Unknown Academy",
            assetName: matchingAsset?.title || "N/A",
            area: matchingAsset?.assetArea || "N/A",
            description: matchingRequest.description || "N/A",
            totalTechnicians: total,
          };
          return merged;
        })
        .filter(Boolean);

      const sortedFiltered = mergedData.sort((a, b) =>
        b.maintenanceReportID.localeCompare(a.maintenanceReportID),
      );

      setData(sortedFiltered);
    }
  }, [
    maintenanceReport,
    maintenanceRequest,
    academy,
    userByEmial,
    users, // Users dependency might be less critical now but kept for safety
    assets,
  ]);

  useEffect(() => {
    if (isReportsLoading) {
      toast.loading("Loading repair reports...", {
        id: "loading-repair-reports",
      });
    } else {
      toast.dismiss("loading-repair-reports");
    }
  }, [isReportsLoading]);

  const handleDownloadSelected = () => {
    if (selectedRows.length === 0) return;

    const selectedData = data.filter((item) =>
      selectedRows.includes(item.maintenanceReportID),
    );

    const csvContent = [
      [
        "Repair ID",
        "Asset Name",
        "Start Time",
        "End Time",
        "Date",
        "Area",
        "Total Cost",
        "Parts Used",
        // "Location",
        "Description",
        "Total Technicians",
        // "Assigned Supervisor",
        "Assigned Technician",
      ],
      ...selectedData.map((item) => [
        item.maintenanceReportID,
        item.assetName,
        item.startTime,
        item.endTime,
        item.finishedDate,
        item.area,
        item.totalCost,
        item.partsUsed,
        // item.location,
        item.description,
        item.totalTechnicians,
        // item.Assigned_supervisor,
        item.technicians,
      ]),
    ]
      .map((row) =>
        row.map((value) => `"${String(value).replace(/"/g, '""')}"`).join(","),
      )
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "repair_report.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const sortedData = [...data].sort(
    (a, b) => b.maintenanceReportID - a.maintenanceReportID,
  );

  const filteredData = sortedData.filter((item) => {
    const matchesSearch = Object.values(item).some((value) =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase()),
    );

    return matchesSearch;
  });

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const displayedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage,
  );

  const handleSelectRow = (maintenanceReportID) => {
    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.includes(maintenanceReportID)
        ? prevSelectedRows.filter((item) => item !== maintenanceReportID)
        : [...prevSelectedRows, maintenanceReportID],
    );
  };

  const handleDeleteSelected = () => {
    const updatedData = data.filter(
      (item) => !selectedRows.includes(item.maintenanceReportID),
    );
    // Update the data with the filtered result after deletion
    setData(updatedData);
    setSelectedRows([]); // Reset selected rows after deletion
  };

  const handleView = (item) => {
    setModalData(item);
  };
  const handleCloseModal = () => {
    setModalData(null);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditableData((prev) => ({ ...prev, [name]: value }));
  };

  // Ref for the modal
  const modalRef = useRef(null);

  // *Function to handle PDF download*

  // *Function to handle PDF download*
  const handleDownloadPDF = () => {
    if (!modalData) return; // Prevent function execution if no data is selected

    const doc = new jsPDF();

    // Add title
    doc.text("Maintenance Report", 14, 15);

    // Define table headers
    const columns = ["Field", "Value"];

    // Map modalData dynamically into table rows
    const rows = [
      ["RID", modalData.maintenanceReportID],
      ["Asset Name", modalData.assetName],
      ["Start Time", modalData.startTime],
      ["End Time", modalData.endTime],
      ["Date", modalData.finishedDate],
      ["Area", modalData.area],
      ["Total Cost", modalData.totalCost],
      ["Part Used", modalData.partsUsed],
      // ["Location", modalData.location],
      ["Description", modalData.description],
      ["Total Technicians", modalData.totalTechnicians],
      // ["Assigned Supervisor", modalData.Assigned_supervisor],
      ["Assigned Technician", modalData.technicians],
      ["Additional Info", modalData.information],
    ];

    // Generate the table using autoTable
    autoTable(doc, {
      head: [columns],
      body: rows,
      startY: 20,
      theme: "grid",
      styles: { fontSize: 10 },
      headStyles: { fillColor: [41, 128, 185] }, // Blue header background
    });

    // Save the PDF
    doc.save(`maintenance_Report_${modalData.maintenanceReportID}.pdf`);
  };

  const [sortOrder, setSortOrder] = useState({ column: null, ascending: true });
  const sortData = (column, ascending) => {
    const sortedData = [...data].sort((a, b) => {
      if (a[column] < b[column]) return ascending ? -1 : 1;
      if (a[column] > b[column]) return ascending ? 1 : -1;
      return 0;
    });
    setData(sortedData);
  };

  const handleSort = (column) => {
    const newSortOrder =
      column === sortOrder.column
        ? !sortOrder.ascending // Toggle the sorting direction if the same column is clicked
        : true; // Start with ascending for a new column

    setSortOrder({
      column,
      ascending: newSortOrder,
    });
    sortData(column, newSortOrder);
  };
  return (
    <div className="p-4 sm:py-6 sm:px-8 space-y-4">
      {/* Header */}
      <div className="space-y-2 mb-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
          <div className="flex items-center gap-3">
            <h1 className="text-xl sm:text-2xl font-bold text-zinc-800">
              Maintenance Report
            </h1>
          </div>
        </div>
        <p className="text-zinc-600">
          View and analyze preventive maintenance reports and statistics
        </p>
      </div>

      <div className="">
        <div className="">
          <div className="flex flex-col lg:flex-row gap-4 mb-6 lg:items-center lg:justify-between">
            <div className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto">
              {/* Search Input */}
              <div className="w-full lg:flex-1 lg:min-w-60">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search maintenance reports..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full p-3 border border-gray-300 rounded-lg pl-10 text-sm sm:text-base"
                  />
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg
                      className="h-4 w-4 sm:h-5 sm:w-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto">
              <button
                onClick={handleDownloadSelected}
                className="inline-flex items-center px-4 py-2 bg-[#305845] text-white text-sm font-medium rounded-lg hover:bg-[#2a4d3a] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#305845] transition-colors"
              >
                <LuDownload className="w-4 h-4 mr-2" />
                Download
              </button>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="overflow-x-auto min-w-0">
              <table className="w-full min-w-max">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      <input
                        type="checkbox"
                        checked={
                          selectedRows.length === displayedData.length &&
                          displayedData.length > 0
                        }
                        onChange={() =>
                          setSelectedRows(
                            selectedRows.length === displayedData.length
                              ? []
                              : displayedData.map(
                                  (item) => item.maintenanceReportID,
                                ),
                          )
                        }
                        className="rounded border-gray-300 text-green-600 focus:ring-green-500"
                      />
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Sl. No.
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Asset Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Time
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Date
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Area
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Total Cost
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Parts Used
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Description
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {displayedData.map((item, index) => (
                    <tr
                      key={item.maintenanceReportID || index}
                      className="hover:bg-gray-50"
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <input
                          type="checkbox"
                          checked={selectedRows.includes(
                            item.maintenanceReportID,
                          )}
                          onChange={() =>
                            handleSelectRow(item.maintenanceReportID)
                          }
                          className="rounded border-gray-300 text-green-600 focus:ring-green-500"
                        />
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {index + 1}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.assetName}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {[item.startTime, item.endTime].join(" - ")}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.finishedDate}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.area}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.totalCost}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.partsUsed}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.description}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <button
                          className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                          onClick={() => handleView(item)}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className="pagination">
            <span>{filteredData.length} Results</span>
            <div>
              {[...Array(totalPages).keys()].slice(0, 5).map((num) => (
                <button
                  key={num}
                  className={currentPage === num + 1 ? "active" : ""}
                  onClick={() => setCurrentPage(num + 1)}
                >
                  {num + 1}
                </button>
              ))}
              <span>...</span>
              <button onClick={() => setCurrentPage(totalPages)}>
                {totalPages}
              </button>
            </div>
          </div>
          {selectedRows.length > 0 && (
            <button
              className="delete-selected-btn"
              onClick={handleDeleteSelected}
            ></button>
          )}
        </div>

        {/* Repair Report Modal */}
        <Dialog
          open={!!modalData}
          onOpenChange={(open) => !open && handleCloseModal()}
        >
          <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle className="text-2xl font-bold flex items-center gap-2">
                <FileText className="h-6 w-6 text-blue-600" />
                Repair Report
              </DialogTitle>
            </DialogHeader>

            {modalData && (
              <div className="space-y-6 py-4">
                {/* Asset Name */}
                <div className="space-y-2">
                  <Label className="text-sm font-medium flex items-center gap-2">
                    <Wrench className="h-4 w-4 text-slate-600" />
                    Asset Name
                  </Label>
                  <Input
                    value={modalData.assetName}
                    readOnly
                    className="bg-slate-50"
                  />
                </div>

                {/* Time and Date Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Label className="text-sm font-medium flex items-center gap-2">
                      <Clock className="h-4 w-4 text-slate-600" />
                      Start Time
                    </Label>
                    <Input
                      value={modalData.startTime}
                      readOnly
                      className="bg-slate-50"
                    />
                  </div>
                  <div className="space-y-2">
                    <Label className="text-sm font-medium flex items-center gap-2">
                      <Clock className="h-4 w-4 text-slate-600" />
                      End Time
                    </Label>
                    <Input
                      value={modalData.endTime}
                      readOnly
                      className="bg-slate-50"
                    />
                  </div>
                </div>

                {/* Date and Area Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Label className="text-sm font-medium flex items-center gap-2">
                      <Calendar className="h-4 w-4 text-slate-600" />
                      Finished Date
                    </Label>
                    <Input
                      value={modalData.finishedDate}
                      readOnly
                      className="bg-slate-50"
                    />
                  </div>
                  <div className="space-y-2">
                    <Label className="text-sm font-medium flex items-center gap-2">
                      <MapPin className="h-4 w-4 text-slate-600" />
                      Area
                    </Label>
                    <Input
                      value={modalData.area}
                      readOnly
                      className="bg-slate-50"
                    />
                  </div>
                </div>

                {/* Parts Used and Total Cost Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Label className="text-sm font-medium flex items-center gap-2">
                      <Wrench className="h-4 w-4 text-slate-600" />
                      Parts Used
                    </Label>
                    <Input
                      value={modalData.partsUsed}
                      readOnly
                      className="bg-slate-50"
                    />
                  </div>
                  <div className="space-y-2">
                    <Label className="text-sm font-medium flex items-center gap-2">
                      <DollarSign className="h-4 w-4 text-slate-600" />
                      Total Cost
                    </Label>
                    <Input
                      value={modalData.totalCost}
                      readOnly
                      className="bg-slate-50"
                    />
                  </div>
                </div>

                {/* Technicians Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Label className="text-sm font-medium flex items-center gap-2">
                      <Users className="h-4 w-4 text-slate-600" />
                      Total Technicians
                    </Label>
                    <Input
                      value={modalData.totalTechnicians}
                      readOnly
                      className="bg-slate-50"
                    />
                  </div>
                  <div className="space-y-2">
                    <Label className="text-sm font-medium flex items-center gap-2">
                      <Users className="h-4 w-4 text-slate-600" />
                      Assigned Technicians
                    </Label>
                    <Input
                      value={modalData.technicians}
                      readOnly
                      className="bg-slate-50"
                    />
                  </div>
                </div>

                {/* Description */}
                <div className="space-y-2">
                  <Label className="text-sm font-medium flex items-center gap-2">
                    <Info className="h-4 w-4 text-slate-600" />
                    Description
                  </Label>
                  <Textarea
                    value={modalData.description}
                    readOnly
                    className="bg-slate-50 min-h-[100px]"
                  />
                </div>

                {/* Additional Information */}
                <div className="space-y-2">
                  <Label className="text-sm font-medium flex items-center gap-2">
                    <Info className="h-4 w-4 text-slate-600" />
                    Additional Information
                  </Label>
                  <Textarea
                    value={modalData.information}
                    readOnly
                    className="bg-slate-50 min-h-[100px]"
                  />
                </div>

                {/* Repaired Images */}
                <div className="space-y-2">
                  <Label className="text-sm font-medium flex items-center gap-2">
                    <ImageIcon className="h-4 w-4 text-slate-600" />
                    Repaired Images
                  </Label>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-4 p-4 border rounded-lg bg-slate-50">
                    {Array.isArray(modalData.images) &&
                    modalData.images.length > 0 ? (
                      modalData.images.map((imgSrc, index) => (
                        <div
                          key={index}
                          className="relative aspect-square rounded-lg overflow-hidden border border-slate-200"
                        >
                          <img
                            src={imgSrc}
                            alt={`Repair ${index + 1}`}
                            className="w-full h-full object-cover hover:scale-105 transition-transform"
                          />
                        </div>
                      ))
                    ) : modalData.images ? (
                      <div className="relative aspect-square rounded-lg overflow-hidden border border-slate-200">
                        <img
                          src={modalData.images}
                          alt="Repair"
                          className="w-full h-full object-cover hover:scale-105 transition-transform"
                        />
                      </div>
                    ) : (
                      <p className="text-slate-500 col-span-full text-center py-4">
                        No images available
                      </p>
                    )}
                  </div>
                </div>
              </div>
            )}

            <DialogFooter>
              <Button variant="outline" onClick={handleCloseModal}>
                Close
              </Button>
              <Button onClick={handleDownloadPDF} className="gap-2">
                <Download className="h-4 w-4" />
                Download PDF
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};

export default SupervisorMReport;
